import {Component, OnInit} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {TranslateService} from '@ngx-translate/core';
import {environment} from 'src/environments/environment';
import {activeLanguageKey} from './shared/dashboard/change-language/change-language.component';
import {TokenService} from './shared/token.service';
import {COOKIE_CONSENT, getCookie} from './config/cookies.config';
import {CookieConsentService} from './cookie-consent-dialog/cookie-consent.service';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {NgxHotjarService} from 'ngx-hotjar';

const defaultLanguage = 'pl';
declare let gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'kns-core';
  private googleAnalytics: boolean = false;
  private hotJar: boolean = false;

  constructor(oauthService: OAuthService, translate: TranslateService, tokenService: TokenService,
              private router: Router,
              public hjService: NgxHotjarService,
              public cookieConsentService: CookieConsentService) {
    oauthService.configure(environment.authConfig);
    oauthService.loadDiscoveryDocument();
    oauthService.timeoutFactor = 0.75;
    oauthService.setupAutomaticSilentRefresh(null, 'access_token');
    tokenService.logoutOnTokenExpired();

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang(defaultLanguage);
    const languageName = localStorage.getItem(activeLanguageKey);

    if (languageName) {
      // this.selectedLanguageService.setSelectedLanguage(languageName);
      translate.use(languageName);
    } else {
      // this.selectedLanguageService.setSelectedLanguage(languageName);
      translate.use(environment.language);
    }

  }

  ngOnInit(): void {
    if (!getCookie(COOKIE_CONSENT)) {
      window[`ga-disable-${environment.ga}`] = true;
      this.cookieConsentService.openCookieConsentDialog();
    } else {
      const cookieConsent = getCookie(COOKIE_CONSENT).split('|');
      this.googleAnalytics = cookieConsent[0] === '1';
      window[`ga-disable-${environment.ga}`] = !this.googleAnalytics || !environment.production;
      if (this.googleAnalytics && environment.production) {
        this.setUpAnalytics();
      }
    }
  }

  setUpAnalytics() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
          gtag('config', environment.ga,
            {
              page_path: event.urlAfterRedirects
            }
          );
      });
  }

}
